import React from 'react';
import { createRoot } from 'react-dom/client';
import FcomifyStandalone from './FcomifyStandalone';

// Find the <div id="root"> inside index.html
const container = document.getElementById('root');
const root = createRoot(container);

// Inject the standalone CRM into the HTML
root.render(
  <React.StrictMode>
    <FcomifyStandalone />
  </React.StrictMode>
);